
import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/73223bde85aca2e90da09d2a7eecf978.jpg" 
          alt="Novacréditos Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900/85 via-slate-900/75 to-slate-900/85"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-32 text-center w-full">
        <div className="inline-flex items-center space-x-2 bg-emerald-600/20 border border-emerald-500/30 rounded-full px-5 py-2 mb-8">
          <i className="ri-shield-check-fill text-emerald-400"></i>
          <span className="text-sm text-emerald-300 font-medium">Plataforma Financiera Certificada</span>
        </div>

        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
          Soluciones Financieras<br />
          <span className="text-emerald-400">Confiables y Seguras</span>
        </h1>

        <p className="text-xl md:text-2xl text-slate-300 mb-4 max-w-3xl mx-auto leading-relaxed">
          Financiamiento profesional en Chile, Perú y México
        </p>

        <p className="text-base text-slate-400 mb-12 max-w-2xl mx-auto">
          Evaluación rápida • Confidencialidad total • Asesoría personalizada • Cumplimiento normativo garantizado
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16">
          <Link to="/solicitar-credito" className="px-8 py-4 bg-emerald-600 text-white text-base font-semibold rounded-lg hover:bg-emerald-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap">
            Solicitar Crédito en Línea
          </Link>
          <Link to="/simulador" className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white text-base font-semibold rounded-lg hover:bg-white/20 transition-all border border-white/20 whitespace-nowrap">
            Simular mi Crédito
          </Link>
          <Link to="/registro" className="px-8 py-4 bg-transparent text-white text-base font-semibold rounded-lg hover:bg-white/10 transition-all border border-white/30 whitespace-nowrap">
            Registrarse Ahora
          </Link>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-8">
          <div className="flex items-center space-x-3 bg-white/5 backdrop-blur-sm rounded-lg px-6 py-3 border border-white/10">
            <i className="ri-government-fill text-emerald-400 text-2xl"></i>
            <div className="text-left">
              <p className="text-xs text-slate-400">Regulado por</p>
              <p className="text-sm text-white font-semibold">Autoridades Financieras</p>
            </div>
          </div>
          <div className="flex items-center space-x-3 bg-white/5 backdrop-blur-sm rounded-lg px-6 py-3 border border-white/10">
            <i className="ri-shield-check-fill text-emerald-400 text-2xl"></i>
            <div className="text-left">
              <p className="text-xs text-slate-400">Certificación</p>
              <p className="text-sm text-white font-semibold">ISO 27001</p>
            </div>
          </div>
          <div className="flex items-center space-x-3 bg-white/5 backdrop-blur-sm rounded-lg px-6 py-3 border border-white/10">
            <i className="ri-lock-fill text-emerald-400 text-2xl"></i>
            <div className="text-left">
              <p className="text-xs text-slate-400">Seguridad</p>
              <p className="text-sm text-white font-semibold">Cifrado SSL 256-bit</p>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl opacity-50"></i>
      </div>
    </section>
  );
}
